import { useQuery } from '@tanstack/react-query'
import { httpGetLuxeFeatureFlags } from '@/features/luxe-submissions/http/luxe-submissions.http'
import type { LuxeFeatureFlagKey } from '@/features/luxe-submissions/types'

export const LUXE_FEATURE_FLAGS_QUERY_KEY = 'luxe-feature-flags'

export const useGetLuxeFeatureFlags = () =>
	useQuery({
		queryKey: [LUXE_FEATURE_FLAGS_QUERY_KEY],
		queryFn: httpGetLuxeFeatureFlags
	})

/**
 * Reads a single Visual Vetting 2.0 flag. A key the backend does not report is
 * treated as off, so the UI stays identical to production until the backend
 * turns the piece on.
 */
export const useLuxeFeatureFlag = (flagKey?: LuxeFeatureFlagKey) => {
	const { data, isLoading } = useGetLuxeFeatureFlags()

	if (!flagKey) {
		return { isEnabled: false, isLoading: false }
	}

	return {
		isEnabled: data?.flags[flagKey] ?? false,
		isLoading
	}
}
